import React from 'react'
import PropTypes from 'prop-types'
import { visit } from 'unist-util-visit'
import { toString } from 'hast-util-to-string'

import { detectLink } from '../link'

export const Link = ({ href, children, ...extraProps }) => {
  const { Component, props } = detectLink(href)
  return (
    <Component {...extraProps} {...props}>
      {children}
    </Component>
  )
}
Link.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export const links = ({ map = [] } = {}) => {
  return (tree, file) => {
    visit(tree, 'element', (node) => {
      if (node.properties.href) {
        const link = detectLink(node.properties.href)
        const text = toString(node)
        map.push({ ...link, text })
      }
    })
    file.links = map
  }
}

export const linkMap = (links) =>
  links.reduce((obj, { type, id }) => ({ ...obj, [type]: [...(obj[type] || []), id] }), {})
